import { formatDate } from "../utils/format-utils";
import ServicePlan from "./ServicePlan";
import Client from "./Client";
import store from "../store/index";

export default class Plan {
  planId?: number | null;
  clientId?: number | null;
  client?: Client | null;
  planStartDate?: Date | null;
  planMeetingDate?: Date | null;
  nextMeetingScheduledDate?: Date | null;
  closureDate?: Date | null;
  planTypeId?: number | null;
  planType?: string | null;
  isSummerSemesterIncluded?: boolean | null;
  languageId?: number | null;
  servicePlans?: ServicePlan[] | null;

  public constructor(params: Plan = {} as Plan) {
    let {
      planId = 0,
      clientId = null,
      client = null,
      planStartDate = null,
      planMeetingDate = null,
      nextMeetingScheduledDate = null,
      closureDate = null,
      planTypeId = null,
      planType = null,
      isSummerSemesterIncluded = null,
      languageId = null,
      servicePlans = null,
    } = params;
    this.planId = planId;
    this.clientId = clientId;
    this.client = client && new Client(client);
    this.planStartDate = planStartDate;
    this.planMeetingDate = planMeetingDate;
    this.nextMeetingScheduledDate = nextMeetingScheduledDate;
    this.closureDate = closureDate;
    this.planTypeId = planTypeId;
    this.planType = planType;
    this.isSummerSemesterIncluded = isSummerSemesterIncluded;
    this.languageId = languageId;
    this.servicePlans =
      servicePlans && servicePlans.map((item) => new ServicePlan(item));
  }
  get formattedStartDate() {
    return formatDate(this.planStartDate);
  }
  get formattedMeetingDate() {
    return formatDate(this.planMeetingDate);
  }
  get formattedNextMeetingScheduledDate() {
    return formatDate(this.nextMeetingScheduledDate);
  }
  get formattedEndDate() {
    return formatDate(this.closureDate);
  }
  get isActive() {
    return this.closureDate == null || this.closureDate >= new Date();
  }
  get ageCategory() {
    return store.getters["optionsModule/getAgeCategoryByPlanType"](
      this.planTypeId
    );
  }
  get language() {
    return (
      store.getters["optionsModule/getLanguageById"](this.languageId)?.name ??
      ""
    );
  }
  get currentSeitServicePlans() {
    let today = new Date();
    return (
      this.servicePlans &&
      this.servicePlans.filter(
        (x) =>
          x.isSeitOrPend &&
          x.startDate != null &&
          new Date(x.startDate) <= today &&
          (x.endDate == null || new Date(x.endDate) >= today)
      )
    );
  }

  get isIncomplete() {
    return this.planType == "Unassigned";
  }
}
